import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./pages/Home";
import Info from "./pages/info";

function App() {
  return (
    <Router>
      <Routes>
        {/* Route for the default Home component */}
        <Route path="/" element={<Home />} />

        {/* Route for the Info component when URL ends with /info */}
        <Route path="/info" element={<Info />} />
      </Routes>
    </Router>
  );
}

export default App;
